import type {
  ClauseBulkAccessRequest,
  ClauseBulkAccessResult,
} from '~/features/access-control/types/AccessControl';

import { ServiceRequestConfig } from '~/services/createService';
import { clausewitz } from '~/services/serviceInstances';

import type { ServerClauseBulkAccessResult } from './clauseBulkAccessMapper';

import {
  mapClauseBulkAccessRequest,
  mapClauseBulkAccessResultResponse,
} from './clauseBulkAccessMapper';

export const bulkUpdateClauseAccess = async (
  request: ClauseBulkAccessRequest,
  options: ServiceRequestConfig = {},
): Promise<ClauseBulkAccessResult> => {
  const serverResponse = await clausewitz.post<ServerClauseBulkAccessResult>(
    '/access/bulk',
    mapClauseBulkAccessRequest(request),
    options,
  );

  return mapClauseBulkAccessResultResponse(serverResponse, request);
};
